import ForgotPassword from "./forgot-password";
import { connect } from "react-redux";
import { getValue } from "store/languages";
import { modalShowToggle } from "store/modal";

let mapStateToProps = (state) => {
    return {
        errorInResetPassword: state.authorization.errorInResetPassword,
    }
}

const ForgotPasswordContainer = (connect(mapStateToProps, {getValue, modalShowToggle})(ForgotPassword));

export default ForgotPasswordContainer;